import curry from 'lodash/curry';
import algoliasearch from 'algoliasearch';

import { AppSettingsModule } from 'services/settings.provider';

import { DataServiceModule } from './data.service';

export const SearchServiceModule = angular
    .module('app.services.data.searchService', [
        DataServiceModule,
        AppSettingsModule
    ]).service('searchService', (
        dataService,
        settings,
        $q
    ) => {
        let client = null;

        return {
            setApiKey: setApiKey,
            search: search,
            getAll: getAll,
            getManyByIds: getManyByIds
        };

        function setApiKey() {
            return dataService.get(settings.api.searchKey).then((response) => {
                client = algoliasearch(process.env.ALGOLIAAPPID, response);
            });
        }

        function searchIndex(indexName, query, options, restrictSearchToName = true) {
            var index = client.initIndex(indexName);

            // wrap with $q to fix native promise bug:
            // https://github.com/angular/material/issues/5485
            // was leading to permanent loading state on autocomplete
            let deferred = $q.defer();
            let restrictOptions = restrictSearchToName ? { restrictSearchableAttributes: 'name' } : {};

            index.search(query, angular.extend({}, restrictOptions, options)).then(res => deferred.resolve(res));

            return deferred.promise;
        }

        function search(indexName, query, options = {}, restrictSearchToName) {
            let performSearch = curry(searchIndex)(indexName);

            return client
                ? performSearch(query, options, restrictSearchToName)
                : setApiKey().then(() => performSearch(query, options, restrictSearchToName));
        }

        function getAll(indexName, query, options = {}) {
            let performSearch = curry(searchIndex)(indexName);

            return client ?
                performSearch(query, options, false) :
                setApiKey().then(() => performSearch(query, options, false));
        }

        function getObjects(indexName, idList) {
            let index = client.initIndex(indexName);
            return index.getObjects(idList);
        }

        function getManyByIds(indexName, ids) {
            let performGetManyByIds = curry(getObjects)(indexName);
            return client ? performGetManyByIds(ids) : setApiKey().then(() => performGetManyByIds(ids));
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/search.service.js